import React from 'react';
import PlayButtonOverlay from 'components/PlayButtonOverlay';
import Thumbnail from 'components/Thumbnail';
import * as S from './styles';
import { ThumbnailButtonProps } from './types';

/**
 * Clickable thumbnail component.
 *
 * This is basically a `Thumbnail` wrapped in a button.  If the `variant` prop is
 * "media", then the thumbnail renders as a click target for opening a video with
 * a play button that appears on hover.
 */
const ThumbnailButton: React.FC<ThumbnailButtonProps> = ({
  onPress,
  variant,
  ...props
}) => {
  if (variant === 'default') {
    return (
      <S.Button onPress={onPress}>
        <Thumbnail {...props} />
      </S.Button>
    );
  }

  return (
    <S.Button onPress={onPress}>
      <Thumbnail {...props} />
      <S.PlayButtonContainer>
        {/*
          play button is just decorative. the thumbnail handles all of the clicks.
          in terms of accessibility, we don't want a nested button, so render as a div,
          remove from focus, and hide it from screen readers
        */}
        <PlayButtonOverlay
          aria-hidden="true"
          excludeFromTabOrder
          buttonAs="div"
          onPress={onPress}
        />
      </S.PlayButtonContainer>
    </S.Button>
  );
};

export default ThumbnailButton;
